import _extends from "../../../../@babel/runtime/helpers/esm/extends.es.js";
import * as React from "react";
import { clsx } from "../../../../clsx/dist/clsx.es.js";
import { styled } from "@mui/system";
import { useGridRootProps } from "../../hooks/utils/useGridRootProps.es.js";
import { getDataGridUtilityClass } from "../../constants/gridClasses.es.js";
import { j as jsxRuntimeExports } from "../../../../react/jsx-runtime.es.js";
import composeClasses from "../../../utils/composeClasses/composeClasses.es.js";
const useUtilityClasses = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["virtualScroller"]
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const VirtualScrollerRoot = styled("div", {
  name: "MuiDataGrid",
  slot: "VirtualScroller",
  overridesResolver: (props, styles) => styles.virtualScroller
})({
  overflow: "auto",
  height: "100%",
  // See https://github.com/mui/mui-x/issues/4360
  position: "relative",
  "@media print": {
    overflow: "hidden"
  },
  zIndex: 0
  // See https://github.com/mui/mui-x/issues/10547
});
const GridVirtualScroller = /* @__PURE__ */ React.forwardRef(function GridVirtualScroller2(props, ref) {
  const rootProps = useGridRootProps();
  const classes = useUtilityClasses(rootProps);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(VirtualScrollerRoot, _extends({
    ref
  }, props, {
    className: clsx(classes.root, props.className),
    ownerState: rootProps
  }));
});
export {
  GridVirtualScroller
};
//# sourceMappingURL=GridVirtualScroller.es.js.map
